import React from 'react';
import { PageLayout } from '@gumtree/shared/src/types/srp';
import { useTheme } from '@emotion/react';
import { DeliveryWrapper, DeliveryText, textButtonCss } from './listing-tile.style';
import { Button } from '..';
import GumtreeLogo from '../logo/gumtree-logo.svg';

export interface Props {
    pageLayout: PageLayout;
}

const DeliveryTile = ({ pageLayout }: Props) => {
    const theme = useTheme();

    return (
        <DeliveryWrapper pageLayout={pageLayout}>
            <DeliveryText>Get your items delivered with Gumtree</DeliveryText>
            <Button label="Learn more" onClick={() => {}} css={textButtonCss(theme)} />
            <GumtreeLogo />
        </DeliveryWrapper>
    );
};

export default DeliveryTile;
